import { Icon, IconProps } from '@chakra-ui/icons';
import React from 'react';

export const YellowPin = (props: IconProps) => (
  <Icon width="14" height="20" viewBox="0 0 14 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M6.23563 0.264108C3.06408 0.60855 0.523261 3.21647 0.250391 6.39696C0.151979 7.55554 0.34433 8.66044 0.764818 9.64903L5.04574 18.5553C5.82856 20.1836 8.15019 20.1836 8.93301 18.5553L13.2139 9.64903C13.5629 8.8349 13.7552 7.93577 13.7552 6.99638C13.7597 3.00622 10.3153 -0.174272 6.23563 0.264108ZM6.99161 9.04961C5.36782 9.04961 4.05715 7.73447 4.05715 6.11515C4.05715 4.49582 5.37229 3.18068 6.99161 3.18068C8.61094 3.18068 9.92608 4.49582 9.92608 6.11515C9.92608 7.73447 8.61094 9.04961 6.99161 9.04961Z"
      fill="#FDC506"
      stroke="black"
      strokeWidth="0.2"
      strokeMiterlimit="10"
    />
  </Icon>
);
